// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"d6c282ca","239":"f86a67f9","357":"f93b870c","455":"c4eaf49b","977":"100e59f4"}[chunkId] + ".chunk.js";
};